import mergeSmimeDecodedMessageProperties from '../actions/mergeSmimeDecodedMessageProperties';
import mergeSmimeDecodedProperties from '../actions/mergeSmimeDecodedProperties';
import mergeSmimeOnlyProperties from '../actions/mergeSmimeOnlyProperties';
import SmimeMessage from 'owa-smime-adapter/lib/store/schema/SmimeMessage';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import ItemId from 'owa-service/lib/contract/ItemId';
import { orchestrator } from 'satcheljs';
import Message from 'owa-service/lib/contract/Message';

export default orchestrator(mergeSmimeDecodedProperties, actionMessage => {
    const itemId: ItemId = actionMessage.itemId;
    const smimeMessage: SmimeMessage = actionMessage.smimeMessage;
    const message = <Message>(itemId?.Id && getMailStore().items.get(itemId.Id));

    mergeSmimeDecodedMessageProperties(message, smimeMessage);
    mergeSmimeOnlyProperties(itemId, smimeMessage);
});
